import { toast } from 'react-toastify';

export const notify = (customText?: string, opt?: any): void => {
  customText && customText.length > 0
    ? toast(customText, opt)
    : toast('Génération du document en cours. Cette opération peut prendre plusieurs secondes.', opt);
};
